'use client'

import { useEffect } from 'react'

/** Adds the `.in` class to every `.rv` element once it scrolls into view. */
export const RevealController = () => {
  useEffect(() => {
    const items = Array.from(document.querySelectorAll<HTMLElement>('.rv'))

    const io = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            entry.target.classList.add('in')
            io.unobserve(entry.target)
          }
        }
      },
      { threshold: 0, rootMargin: '0px 0px -8% 0px' },
    )
    items.forEach((el) => {return io.observe(el)})

    // Safety net: anything already above or inside the viewport must never stay hidden.
    const reveal = () => {
      const bottom = window.innerHeight * 0.95
      for (const el of items) {
        if (!el.classList.contains('in') && el.getBoundingClientRect().top < bottom) {
          el.classList.add('in')
          io.unobserve(el)
        }
      }
    }
    reveal()
    window.addEventListener('scroll', reveal, { passive: true })
    window.addEventListener('resize', reveal)

    return () => {
      io.disconnect()
      window.removeEventListener('scroll', reveal)
      window.removeEventListener('resize', reveal)
    }
  }, [])

  return null
}
